import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-footer-bg text-footer-foreground pt-10 sm:pt-14 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid sm:grid-cols-2 gap-8 sm:gap-12 mb-10">
          <div>
            <h3 className="text-white text-lg font-bold mb-4 tracking-wide">{t("footer.requisites")}</h3>
            <div className="space-y-1 text-sm leading-relaxed">
              <p>SIA „MJ-Partneri"</p>
              <p>Reģ.Nr. 40003923427</p>
              <p>Bajāru iela 44, Rīga, LV-1006</p>
              <p>AS „Swedbank"</p>
              <p>LV60HABA0551016727460</p>
              <p className="mt-3">Valdes priekšsēdētājs Juris Leitāns</p>
            </div>
          </div>
          <div>
            <h3 className="text-white text-lg font-bold mb-4 tracking-wide">{t("footer.contacts")}</h3>
            <div className="space-y-1 text-sm leading-relaxed">
              <p>{t("footer.address")}: Bajāru iela 44</p>
              <p>Rīga, LV-1006</p>
              <p>
                {t("footer.phone")}:{" "}
                <a href="tel:+37167817777" className="text-white/90 hover:text-white transition-colors underline-offset-2 hover:underline">
                  +371 67817777
                </a>
              </p>
              <p>
                {t("contact.email")}:{" "}
                <a href="mailto:info@mj.lv" className="text-white/90 hover:text-white transition-colors underline-offset-2 hover:underline">
                  info@mj.lv
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-footer-foreground">
          <span>© {new Date().getFullYear()} MJ-Partneri. {t("footer.rights")}</span>
          <span>
            Created by:{" "}
            <a href="https://kanepons.lv" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-white transition-colors underline-offset-2 hover:underline">
              Kanepons.lv
            </a>
          </span>
        </div>
        <div className="mt-4 text-center">
          <Link to="/admin" className="text-footer-foreground/40 hover:text-footer-foreground/70 transition-colors text-xs py-1 px-2 inline-block">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
